import React from 'react';

// This is absolutely fugly
// every time we update something in the user profile that might cause data to be invalidated across the page
// we'll increment this counter. The value then can be used in useEffects array of dependencies to force a refetch
// eslint
export default React.createContext({ increment: () => {}, value: 0 });
